import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Lock, Unlock, Trash2, Eye, EyeOff } from 'lucide-react';
import { formatDate } from './adminUtils';

export function TopicsTab({ topics, categories, handleMoveTopic, handleToggleTopicNoindex, handleToggleLock, handleDeleteTopic }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-50">
      {topics.map(t => (
        <div key={t._id} data-testid={`admin-topic-${t._id}`} className="flex items-center gap-3 px-4 py-3 flex-wrap sm:flex-nowrap">
          <div className="flex-1 min-w-0 w-full sm:w-auto">
            <div className="font-medium text-slate-800 truncate">{t.title}</div>
            <div className="text-xs text-slate-400 truncate">{t.category_name} · {t.author_display_name} · {formatDate(t.created_at)}</div>
          </div>
          <Select value={t.category_slug || ''} onValueChange={val => handleMoveTopic(t._id, val)}>
            <SelectTrigger className="w-36 h-8 text-xs" data-testid={`admin-move-topic-${t._id}`} title="Konuyu başka kategoriye taşı">
              <SelectValue placeholder="Kategoriye taşı" />
            </SelectTrigger>
            <SelectContent>
              {categories.map(c => (
                <SelectItem key={c.slug} value={c.slug}>{c.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <div className="flex gap-1 shrink-0">
            <button
              onClick={() => handleToggleTopicNoindex(t._id, t.noindex)}
              className={`p-1.5 rounded-lg transition-colors ${t.noindex ? 'text-amber-600 bg-amber-50' : 'text-slate-400 hover:bg-slate-100'}`}
              data-testid={`admin-noindex-topic-${t._id}`}
              title={t.noindex ? 'Noindex - arama motorlarına kapalı' : 'Arama motorlarında görünür'}
            >
              {t.noindex ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />}
            </button>
            <button
              onClick={() => handleToggleLock(t._id, t.is_locked)}
              className={`p-1.5 rounded-lg transition-colors ${t.is_locked ? 'text-red-500 bg-red-50' : 'text-slate-400 hover:bg-slate-100'}`}
              data-testid={`admin-lock-topic-${t._id}`}
            >
              {t.is_locked ? <Lock className="w-3.5 h-3.5" /> : <Unlock className="w-3.5 h-3.5" />}
            </button>
            <button
              onClick={() => handleDeleteTopic(t._id)}
              className="p-1.5 rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-50 transition-colors"
              data-testid={`admin-delete-topic-${t._id}`}
            >
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      ))}
      {topics.length === 0 && (
        <div className="text-center py-8 text-slate-500">Konu bulunamadı</div>
      )}
    </div>
  );
}
